import { Component, Input } from '@angular/core';

@Component({
    selector: 'project-indicators',
    template: require('./project.indicators.html')
})
export class ProjectIndicatorsComponent {

    @Input() project: any = null;

    constructor() { }   
}